import { SsMount } from 'src/js/dom/mount.js';
import { velocity } from 'src/js/lib/velocity.js';
import { throttle } from 'lodash';
import { isMobile } from 'src/js/lib/snif.js';

export class SsThreadAccord extends SsMount {
  constructor ( elm ) {
    super( elm );
    this.opened = false;
    this.body = new SsMount( elm.querySelector( '.thread-body' ) );
    this.resizeID = throttle( this.resizeLsn.bind( this ), 100 );
  }

  resizeLsn () {
    if ( isMobile() ) {
      if ( this.opened ) {
        // this.$.height( this.getHeight() );
        this.$.height( 'auto' );
      } else {
        this.$.height( 0 );
      }
    } else {
      this.$.css( 'height', 'auto' );
    }
  }

  async toggle () {
    if ( ! this.opened ) {
      await this.open();
    } else {
      await this.close();
    }
    this.opened = ! this.opened;
    this.resizeLsn();
    return Promise.resolve();
  }

  open () {
    return velocity( this.elm, {
      props: {
        height: [ this.getHeight(), 0 ],
      },
      opts: {
        duration: 300,
        easing: 'easeInOutCubic',
      },
      cb: () => {
        this.onResize();
      }
    })
  }

  close () {
    return velocity( this.elm, {
      props: {
        height: [ 0, this.getHeight() ],
      },
      opts: {
        duration: 300,
        easing: 'easeInOutSine',
      },
    });
  }

  onResize () {
    window.addEventListener( 'resize', this.resizeID );
  }

  offResize () {
    window.removeEventListener( 'resize', this.resizeID );
  }

  getHeight () {
    return this.body.$.innerHeight();
  }
}
